
import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MessageBoxService, MessageBoxData } from './message-box.service';

@Component({
  selector: 'app-message-box',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './message-box.component.html',
})
export class MessageBoxComponent {
  messageBoxService = inject(MessageBoxService);

  onConfirm(): void {
    this.messageBoxService.close(true);
  }

  onCancel(): void {
    this.messageBoxService.close(false);
  }
}
